export enum IStock {
  moreThan20 = 'moreThan20',
  moreThan5 = 'moreThan5',
  lessThan5 = 'lessThan5',
  outOfStock = 'outOfStock',
}
